import React    from 'react';

export default function DefaultPage({markdown}){
    return (<section data-markdown={markdown}>
    </section>)
}